import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { RUSTFS_TYPE } from '../../lib/viva';
import { EntityArgoAppsCell } from '../catalog/cells';
import { rustfsColumns } from '../catalog/columns';
import { TypedCatalogPage } from '../catalog/TypedCatalogPage';

const columns = rustfsColumns<CatalogTableRow>(row => (
  <EntityArgoAppsCell entity={row.entity} />
));

/** Раздел «RustFS»: объектное хранилище кластеров на хостах — только просмотр, без создания. */
export const RustfsPage = () => (
  <TypedCatalogPage
    section="rustfs"
    title="RustFS"
    subtitle="Объектное хранилище S3 кластеров на своих хостах: Vault, MLflow, Loki, датасеты, бэкапы PostgreSQL"
    kind="component"
    type={RUSTFS_TYPE}
    columns={columns}
    support="RustFS ставится вместе с кластером на своих хостах и в VK Cloud (шаблон «Новый Kubernetes-кластер», варианты kubespray и VK Cloud, если не выбран VK Object Storage): число подов и пул узлов задаются там же и после создания не меняются. В кластерах Yandex Cloud и cloud.ru вместо него — Object Storage облака. Вход в консоль — учётная запись root кластера (секрет rustfs/rustfs-root)."
    emptyContent={
      <EmptyState
        missing="data"
        title="RustFS пока нет"
        description="RustFS появляется вместе с кластером на своих хостах или в VK Cloud (шаблон «Новый Kubernetes-кластер», варианты kubespray и VK Cloud)."
      />
    }
  />
);
